<template>
  <div> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='applicant-grid'>
      <dx-data-grid ref='refPositionGrid'
        :data-source='positionInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :row-alternation-enabled="false"
        height="150" keyExpr="seqId" :focusedRowEnabled="true"
      >

        <DxSearchPanel
          :visible="false"
          placeholder="검색..."
        />
        <DxExport
          :enabled="false"
        />
        <DxFilterRow
          :visible="false"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>

        <DxColumn
          :allowEditing="isIdEdit"
          :visible="true"
          caption="고객사명"
          data-field="고객사명"
          :min-width="140"
          :fixed="true"
          >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="포지션제목"
        data-field="포지션제목"
        :min-width="300"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="채용진행"
        data-field="채용진행단계"
        :min-width="120"
        alignment="center"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="채용직급"
        data-field="채용직급"
        alignment="center"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="요구경력"
        data-field="경력"
        alignment="center"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="요구학력"
        data-field="학력"
        alignment="center"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="선호성별"
        data-field="선호성별"
        alignment="center"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="선호연령"
        data-field="선호연령"
        alignment="center"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="연봉수준(만)"
        data-field="연봉수준"
        alignment="center"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="컨설턴트"
        data-field="컨설턴트"
        alignment="center"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="모집분야"
        data-field="모집분야"
        :min-width="100"
        alignment="center"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="근무예정지"
        data-field="근무예정지"
        alignment="center"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="기숙조건"
        data-field="기숙조건"
        alignment="center"
        :min-width="100"
        >
        </DxColumn>
      <!-- <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="성명"
            display-format="{0} (건)"
          />
        </DxSummary> -->
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multi"/>
        <template #position-title>
          <div class="toolbar-label" style="font-size:1.1rem;margin-left:4px;">
            {{dataSource.포지션제목}} - 추천현황
          </div>
        </template>
        <template #applicantGridTemplate="{ data: cellInfo }" >
          <ApplicantGridComponent
            :value="cellInfo.value"
            :on-value-changed="cellInfo.setValue"
            @change-selected="onChangedApplicant"
          />
        </template>
      </dx-data-grid>
    </div>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxFilterRow, DxExport, DxColumnFixing, DxPaging, DxScrolling,
  DxColumn, DxSorting, DxSearchPanel } from 'devextreme-vue/data-grid'
import ApplicantGridComponent from '../../share/component/devextream-template/ApplicantGridComponent'

export default {
  name: 'applicantComponent',
  data: function () {
    return {
      isLoading: false,
      userInfo: this.$store.getters.getUserInfo,
      positionInfoList: null,
      focusedRowKey: null,
      selectedRow: null,
      processingLookup: this.$store.getters.getBaseDataByType(ConstDef.지원자진행단계),
      studyLookup: this.$store.getters.getBaseDataByType(ConstDef.최종학력),
      manWoomanLookup: ConstDef.남녀,
      graduateLookup: ConstDef.졸업여부,
      levelLookup: ConstDef.상중하,
      languageLookup: this.$store.getters.getBaseDataByType(ConstDef.외국어능력),
      employeeInfo: this.$store.getters.getEmployee,
      isExporing: false,
      selectedNewApplicant: null,
      isIdEdit: true
    }
  },
  props: {
    dataSource: {
      type: Object,
      default: null
    }
  },
  components: {
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxPaging,
    DxColumnFixing,
    DxColumn,
    DxSorting,
    DxSearchPanel,
    DxScrolling,
    ApplicantGridComponent
  },
  created () {
    console.log(this.processingLookup)
  },
  mounted () {
    this.refreshPosition()
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

    refreshPosition () {
      this.$_sp.runFindProc('spFindAllPositionByApplicant', { 지원자코드: this.dataSource.seqId })
        .then(data => {
          this.positionInfoList = this.$_sp.MakeModel(data)
          console.log(this.positionInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.temp{
  color:#8b8b8b;
}
</style>
